import {
  BOTS_ACTIVITY,
  BOT_ACCESS,
  GEO_CHECKLIST,
  KEYWORDS,
  PROMPTS,
  PROJECTS,
  SOURCES,
  SUGGESTED_PROMPTS,
  TAGS,
} from '../../../../routes/path';
import { ProjectResponse } from '../../../../models/projects/ProjectResponse';
import { AccountResponse } from '../../../../models/account/AccountResponse';
import { Addons } from '../../../../types/account/Addons';

export const reorderedProjects = (projects: ProjectResponse[], location: any) => {
  const activeProject = projects.find(
    (project) =>
      location.pathname.includes(`${PROJECTS}/${project.id}/${project.defaultPeriod.toLowerCase()}`) ||
      location.pathname.includes(`${SUGGESTED_PROMPTS}/${project.id}`) ||
      location.pathname.includes(`${SOURCES}/${project.id}`) ||
      location.pathname.includes(`${TAGS}/${project.id}`) ||
      location.pathname.includes(`${KEYWORDS}/${project.id}`) ||
      location.pathname.includes(`${PROMPTS}/${project.id}`) ||
      location.pathname.includes(`${GEO_CHECKLIST}/${project.id}`) ||
      location.pathname.includes(`${BOTS_ACTIVITY}/${project.id}`) ||
      location.pathname.includes(`${BOT_ACCESS}/${project.id}`)
  );

  if (activeProject) {
    return [activeProject, ...projects.filter((project) => project.id !== activeProject.id)];
  }

  return projects;
};

export const getSubmenuHeight = (
  accountResponse: AccountResponse,
  isMainActive: boolean,
  isDemoVersion: boolean,
  isActiveProject: boolean,
) => {
  if (!isMainActive) {
    return 0;
  }

  const supportedAddons: Addons[] = isDemoVersion
    ? ['SUGGESTED_PROMPTS', 'SOURCES_STATS']
    : isActiveProject
    ? ['SUGGESTED_PROMPTS', 'TAGS', 'KEYWORDS_PAGE', 'PROMPT_GROUP', 'SOURCES_STATS', 'CONTEXT_INSIGHTS']
    : ['SUGGESTED_PROMPTS', 'TAGS', 'KEYWORDS_PAGE', 'PROMPT_GROUP', 'SOURCES_STATS'];

  let height = 18;
  let count = 0;
  for (const addon of supportedAddons) {
    if (accountResponse.addons.includes(addon)) {
      height += 18;
      count += 1;
    }
  }

  // Checklists, Bots Activity, and Bot Access are now always rendered.
  height += 18 * 3;
  count += 3;

  return 15 + height + count * 20;
};
